// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-icon-button{background-size:70%!important;display:block!important;margin:0 auto!important}.fieldsetP{border:none;border:1px solid hsla(0,0%,39%,.5);border:1px solid #009dc0;border-radius:3px}.fieldset-linearP{border:none;border-top:1px solid hsla(0,0%,39%,.5);border-top:1px solid #009dc0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
